import { createFileRoute, redirect } from '@tanstack/react-router';
import { UserRoles } from '~entities/users';
import { checkMinRoleValue } from '~shared/utils/role-guard';
import { queryClient } from '~app/query-client';

import { OutgoingEmailLogsPage } from '~features/outgoing-email-logs';
import { getOutgoingEmailScenariosOptions } from '~features/outgoing-email-logs/api/outgoing-email-logs-api';

function RouteComponent() {
  return <OutgoingEmailLogsPage />;
}

export const Route = createFileRoute('/_auth/_layout/outgoing-email-logs')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }

    await queryClient.ensureQueryData(getOutgoingEmailScenariosOptions());

    return {
      maxAge: 5 * 60 * 1000,
    };
  },
  component: RouteComponent,
});
